import React, {useEffect, useState} from 'react'
import {AppContainer} from '../../../_metronic/helpers/components/AppContainer'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCol,
  MDBContainer,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from 'mdb-react-ui-kit'

import Tippy from '@tippy.js/react'
import 'tippy.js/dist/tippy.css'
import toast, {Toaster} from 'react-hot-toast'
import {FiCheckCircle} from 'react-icons/fi'
import './index.css'
import Wizard from '../../../assets/salecooperation/wizard.svg'
import {Image} from 'react-bootstrap-v5'
import {useSelector} from 'react-redux'
import {RootState} from '../../../reducer/reducer'
import {FiCopy} from 'react-icons/fi'
import PrivateRequest from '../api/PrivateRequest'

const moment = require('moment-jalaali')

const SaleCooperation = () => {
  const [basicModal, setBasicModal] = useState(false)
  const [refUser, setRefUser] = useState({
    person_cooperate_name: '',
    mobile_number: '',
  })
  const [code, setCodes] = useState<any>()
  const toggleShow = () => setBasicModal(!basicModal)

  const UserInfo = useSelector((state: RootState) => {
    return state.UserInfo
  })

  const getReferralsCode = () => {
    PrivateRequest()
      .get('/showreferralcodes')
      .then((res: any) => {
        setCodes(res.data.data)
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  useEffect(() => {
    getReferralsCode()
  }, [])

  const addNewRefUser = () => {
    PrivateRequest()
      .post('add-user-sales-cooperation', refUser)
      .then((res: any) => {
        getReferralsCode()
        toast.success('درخواست شما ثبت شد ')
        setBasicModal(false)
      })
      .catch((err: any) => {
        toast.error(err.response.data.err)
      })
  }

  const Copied = () => {
    toast.success('لینک دعوت شما کپی شد میتوانید این لینک را برای دوستان خود ارسال کنید')
  }
  return (
    <AppContainer title={'همکاری در فروش'}>
      <Image className={'img-fluid'} src={Wizard} />
      <br />
      <Toaster position='top-center' reverseOrder={false} />
      <br />
      <div dir={'rtl'} className={'flex justify-center'}>
        <MDBCard style={{backgroundColor: '#F6F6F6'}} className='mb-3 w-10/12 h-5/12 p-5'>
          <MDBCardBody className='text-primary'>
            <MDBCardTitle>
              <h1 className={'text-gray-600 font-light mb-8'}> کد سهامی شما </h1>
            </MDBCardTitle>
            <br />
            <MDBCardText>
              <MDBRow className={'w-full flex justify-around'}>
                <MDBCol lg={'8'}>
                  <h5 dir={'rtl'} className={'font-light text-right leading-9'}>
                    از این کد می توانید به عنوان کد معرف خود استفاده نمایید و آشنایان خود را دعوت به
                    خرید سهام کنید و از سود 3 درصد فروش سهام بهره مند شوید.
                  </h5>
                </MDBCol>
                <MDBCol className={'flex flex-col justify-center'} lg={'4'}>
                  <div>
                    <MDBBtn onClick={toggleShow} color={'danger'}>
                      ارسال سریع کد معرف
                    </MDBBtn>
                  </div>
                  <br />
                  <Tippy
                    placement='top'
                    className='tippy'
                    arrow={false}
                    content={<span style={{color: 'white'}}> برای کپی کلیک کنید</span>}
                  >
                    <div color={'flex justify-center items-center'} className=' bg-white'>
                      <div onClick={Copied} className={'p-4'}>
                        {UserInfo.UserInfo ? (
                          <CopyToClipboard
                            text={`https://panel.mehriranianco.ir/auth/registration?ref=${UserInfo.UserInfo.referral_code}`}
                          >
                            <MDBBtn
                              color={
                                'white mt-1 flex flex-col justify-center items-center sm:w-full '
                              }
                            >
                              کد معرف شما :
                              <br />
                              <br />
                              <div className='flex'>
                                <div>{UserInfo.UserInfo.referral_code}</div>
                                <div className={'mr-5 bg-primary rounded'}>
                                  <FiCopy className={'text-white m-2'} />
                                </div>
                              </div>
                            </MDBBtn>
                          </CopyToClipboard>
                        ) : (
                          <MDBSpinner role='status'>
                            <span className='visually-hidden'>Loading...</span>
                          </MDBSpinner>
                        )}
                      </div>
                    </div>
                  </Tippy>
                </MDBCol>
              </MDBRow>
            </MDBCardText>
          </MDBCardBody>
        </MDBCard>
        <br />
        <br />
      </div>
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex='-1'>
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader dir={'rtl'}>
              <MDBModalTitle dir={'rtl'} className={'text-center flex justify-center items-center'}>
                ارسال سریع کد برای معرف شما
              </MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className={'flex flex-col'}>
              <div dir={'rtl'}>
                <label className={'text-right flex justify-start mb-4'}>نام شخص مورد نظر:</label>
                <input
                  onChange={(e) => setRefUser({...refUser, person_cooperate_name: e.target.value})}
                  className={'form-control text-center form-control-lg form-control-solid'}
                  placeholder=' نام شخص مورد نظر را وارد کنید  '
                  name='mobile'
                  autoComplete='off'
                />
              </div>
              <br />
              <div>
                <label className={'text-right flex justify-end mb-4'}>: موبایل شخص مورد نظر </label>
                <input
                  onChange={(e) => setRefUser({...refUser, mobile_number: e.target.value})}
                  className={'form-control text-center form-control-lg form-control-solid'}
                  placeholder=' موبایل شخصی که قصد دعوت به خرید سهام را دارید وارد کنید '
                  name='mobile'
                  autoComplete='off'
                />
              </div>
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn onClick={addNewRefUser} className={'bg-teal'}>
                ارسال لینک دعوت{' '}
              </MDBBtn>
              <MDBBtn color='secondary' onClick={toggleShow}>
                بستن
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      <MDBContainer className={'mt-5'} dir='rtl'>
        <h4 className={'m-5 text-right'}>معرف های شما </h4>
        <MDBRow>
          <MDBCol>
            <div className='table-responsive'>
              <MDBTable striped className='table sm:gs-7 sm:gy-7 sm:gx-7  border'>
                <MDBTableHead>
                  <tr className='border text-center'>
                    <th className='th'>ردیف</th>
                    <th className='th'>نام شخص</th>
                    <th className='th'>موبایل شخص</th>
                    <th className='th'> تاریخ درخواست</th>
                    <th className='th'>وضعیت</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody className=' border border-top'>
                  {code &&
                    code.map((item: any, index: number) => {
                      return (
                        <tr className=' border border-bottom text-center' key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.person_cooperate_name}</td>
                          <td>{item.mobile_number}</td>
                          <td>
                            {moment(item.created_at, 'YYYY-M-D HH:mm:ss').format(
                              'HH:mm - jYYYY/jM/jD'
                            )}
                          </td>
                          <td>
                            <button className='bg-red-400 text-white border-0 rounded-md py-1 px-2'>
                              <FiCheckCircle />
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                </MDBTableBody>
              </MDBTable>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </AppContainer>
  )
}

export {SaleCooperation}
